import React from 'react';

import { Card } from 'antd';

import PublicLayout from 'v2/components/Shared/PublicLayout';

const AccountCreated = () => {
  return (
    <PublicLayout>
      <Card>
        <div className='p-[20px] text-center'>
          <p className='text-base font-medium'>Conta bancária enviada para aprovação!</p>
          <p className='text-sm font-medium'>
            Sua conta bancária será moderada pelo nosso setor financeiro. Esse processo costuma ser rápido (de 1 a 5
            dias úteis). Fique tranquilo, vamos nos esforçar para ser no menor tempo possível.
          </p>
        </div>
      </Card>
    </PublicLayout>
  );
};

export default AccountCreated;
